const variantsSelect = document.querySelector("select[data-variants]");
if (variantsSelect) {
    const productVariants = [];
    for (const option of variantsSelect.options) {
        const variantInfo = {
            id: option.value,
            price: option.dataset.price,
            stock: option.dataset.stock,
            values: option.dataset.values,
            options: option.dataset.values.split("|"),
        };
        productVariants.push(variantInfo);
    }

    const productOptions = document.querySelectorAll("[data-options]");
    if (productOptions.length) {
        productOptions.forEach((option) => {
            const values = option.querySelectorAll("[data-value]");
            values.forEach((value) => {
                value.addEventListener("click", function () {
                    if (value.dataset.hasOwnProperty("selected")) return;
                    const current = option.querySelector("[data-selected]");
                    current.removeAttribute("data-selected");
                    current.classList.replace("b--black", "b--near-white");
                    value.dataset.selected = true;
                    value.classList.replace("b--near-white", "b--black");
                    option.dataset.value = value.dataset.value;
                    updateVariant(productOptions, productVariants);
                });
            });
        });
    }
}

function updateVariant(options, variants) {
    const selectedOptions = [];
    options.forEach((option) => {
        selectedOptions.push(option.dataset.value);
    });
    const selectedVariant = variants.find((variant) => variant.values === selectedOptions.join("|"));
    if (selectedVariant) {
        const variantInput = document.querySelector("input[name='id']");
        if (variantInput) variantInput.value = selectedVariant.id;
        const variantOutput = document.querySelectorAll("[data-output]");
        variantOutput.forEach((output) => {
            if (output.dataset.output === "images") {
                const current = output.querySelector("[data-active]");
                if (current) {
                    current.classList.replace("db", "dn");
                    current.removeAttribute("data-active");
                }
                const updated = output.querySelector("[data-variant='" + selectedVariant.id + "']");
                if (updated) {
                    updated.classList.replace("dn", "db");
                    updated.dataset.active = true;
                }
            } else {
                output.textContent = selectedVariant[output.dataset.output];
            }
        });
    }
}

function formatSelectOptionsText(options, current, prepend, append) {
    for (const option of options) {
        if (option.index === current) {
            if (prepend) option.text = prepend + option.text;
            if (append) option.text = option.text + append;
        } else {
            if (prepend) option.text = option.text.replace(prepend, "");
            if (append) option.text = option.text.replace(append, "");
        }
    }
}

const quantityInput = document.querySelector("div[data-input='quantity']");
if (quantityInput) {
    const productQuantity = document.querySelector("input[name='quantity']");
    initQuantityInput(quantityInput, function (input, value) {
        productQuantity.value = value;
    });
}
